import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectNewbuildingsCompareBlocks, selectNewbuildingsComparison } from '../../selectors/newbuildingsCompare';
import { NewbuildingsCompareMobilePage } from '../../components/NewbuildingsCompareMobilePage';
import { NewbuildingCard } from '../../components/NewbuildingsCompareMobilePage/parts/NewbuildingCard';
import { NewbuildingFloatingCard } from '../../components/NewbuildingsCompareMobilePage/parts/NewbuildingFloatingCard';
import { buildNewbuildingsCompareViewRows } from '../NewbuildingsComparePage/buildViewRows';

export const NewbuildingsCompareMobilePageContainer = () => {
  const comparison = useSelector(selectNewbuildingsComparison);
  const blocks = useSelector(selectNewbuildingsCompareBlocks);
  const [isRoomStatsExpanded, setRoomStatsExpanded] = React.useState(false);
  const [pinnedIndex, setPinnedIndex] = React.useState<number | null>(null);

  const handleToggleRoomStats = React.useCallback(() => setRoomStatsExpanded(value => !value), []);
  const handleTogglePin = React.useCallback(
    (index: number) => setPinnedIndex(prev => (prev === index ? null : index)),
    [],
  );

  const { rows, summaryRow } = buildNewbuildingsCompareViewRows({
    blocks,
    isRoomStatsExpanded,
    onToggleRoomStats: handleToggleRoomStats,
  });

  // Закрепление хранится по индексу колонки. При изменении набора ЖК (добавили/удалили/
  // переупорядочили) индексы сдвигаются, поэтому сбрасываем закрепление, чтобы оно не
  // «перепрыгнуло» на другой ЖК.
  const columnsKey = (summaryRow?.cells ?? []).map(cell => cell.data?.id ?? '').join(',');

  React.useEffect(() => {
    setPinnedIndex(null);
  }, [columnsKey]);

  if (!comparison) {
    return null;
  }

  const columns =
    summaryRow?.cells.map((cell, index) => (
      <NewbuildingCard
        cell={cell}
        isPinned={index === pinnedIndex}
        key={index}
        onTogglePin={() => handleTogglePin(index)}
      />
    )) ?? [];

  const floatingColumns =
    summaryRow?.cells.map((cell, index) => <NewbuildingFloatingCard cell={cell} key={index} />) ?? [];

  return (
    <NewbuildingsCompareMobilePage
      columns={columns}
      floatingColumns={floatingColumns}
      pinnedIndex={pinnedIndex}
      rows={rows}
      title={comparison.title}
    />
  );
};
